module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalDefault', {
    attrs: {
      "overlay": false,
      "loading": _vm.loading || _vm.parentLoading
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('h1', {
    staticClass: "title text-center"
  }, [_vm._v(_vm._s(_vm.$trad.userList.title) + " " + _vm._s(_vm.getZone.name))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive mt-5"
  }, [_c('table', {
    staticClass: "table table-stripped"
  }, _vm._l((_vm.usersFiltered), function(user) {
    return _c('tr', [_c('td', [(_vm.hasAccessSuperAdmin() || _vm.currentBrand.id === user.brandId) ? _c('router-link', {
      attrs: {
        "tag": "a",
        "to": '/users/user/' + user.id
      }
    }, [_c('LinkToUserIcon', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "mailto",
      attrs: {
        "href": 'mailto:' + user.email
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")(user.lastname)) + " " + _vm._s(_vm._f("capitalize")(user.firstname)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.profile ? user.profile : ""))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.brands.find(function (b) { return b.id === user.brandId; }).name)))])])
  }))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4955009c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zone/ShowUsers.vue
// module id = 3159
// module chunks = 0